module.exports = __webpack_public_path__ + "static/img/cp4.6858fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp4.png
// module id = HYtq
// module chunks = 0